import React from "react";
import "./Contact.css";
import "./components/ContactComponents.css";
import JoinLegacyForm from "./components/JoinLegacyForm";
import FindDojang from "./components/FindDojang";
import { motion } from "framer-motion";

const Contact = () => {
  return (
    <div className="contact-container">
      <motion.div
      className="contact-reveal"
      initial={{ opacity: 0, y: 40, scale: 0.85 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: false }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
    <div className="modular-contact-container" id="contact">
      <JoinLegacyForm />
      <FindDojang />
    </div>
    </motion.div>
    </div>
  );
};

export default Contact;
